import React, { useState } from 'react';

const EmailChangeModal = ({
    step,
    maskedEmail,
    pendingEmail,
    error,
    isSubmitting,
    onVerify,
    onResend,
    onCancel
}) => {
    const [code, setCode] = useState('');

    const title = step === 'new'
        ? 'Confirmez votre nouvelle adresse'
        : 'Confirmez le remplacement de votre adresse';
    const helper = step === 'new'
        ? `Saisissez le code envoyé à ${maskedEmail || pendingEmail}.`
        : `Saisissez le code envoyé à ${maskedEmail || 'votre adresse actuelle'}.`;

    const handleSubmit = (event) => {
        event.preventDefault();
        onVerify(code.trim());
    };

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content max-w-md" onClick={(event) => event.stopPropagation()}>
                <h2 className="text-2xl font-bold text-theme-primary mb-2">{title}</h2>
                <p className="text-gray-600 mb-4">{helper}</p>
                {pendingEmail && step === 'old' && (
                    <p className="text-sm text-gray-500 mb-4">
                        Nouvelle adresse demandée : <strong>{pendingEmail}</strong>
                    </p>
                )}
                {error && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
                        {error}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <label className="block text-sm font-medium text-gray-700">
                        Code à 6 chiffres
                        <input
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            value={code}
                            onChange={(event) => setCode(event.target.value.replace(/\D/g, '').slice(0, 6))}
                            className="input-theme mt-2 tracking-widest text-center text-xl"
                            placeholder="000000"
                            required
                        />
                    </label>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="btn-theme-secondary flex-1"
                            disabled={isSubmitting}
                        >
                            Annuler
                        </button>
                        <button
                            type="button"
                            onClick={onResend}
                            className="btn-theme-secondary flex-1"
                            disabled={isSubmitting}
                        >
                            Renvoyer le code
                        </button>
                        <button
                            type="submit"
                            className="btn-theme flex-1"
                            disabled={isSubmitting || code.length !== 6}
                        >
                            Valider
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmailChangeModal;
